import React, { useEffect } from "react";
import "./Ece_skill_development.css";
import {
  Backtotop,
  Floatinmenu,
  Underline,
  ContentCard,
} from "../../widgets";
import {
  ece_dept_menu,
  ece_skill_development_data
} from "../../constants/ece_dept";

import { RadialMenu } from "../../components";

import { FaMicrochip } from "react-icons/fa6";

const Ece_stud_activity = () => {
  useEffect(() => {
    document.title = "ACCET-ECE | Skill Development Programmes";
  }, []);
  return (
    <div className="ecedept">
      <div className="ecebg">
        <div className="eceheading">
          Department of Electronics and Communication Engineering
        </div>
        <div className="ece_sub_heading">Skill Development Programmes</div>
      </div>
      <section className="ecedark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaMicrochip} head="Menu" links={ece_dept_menu} />
        </div>
        <RadialMenu menu_links={ece_dept_menu} />
    
        <Underline heading="Skill Development Programmes" />
        <div className="ece_skill_development_card_outer">
          
            {ece_skill_development_data.map((item) => (
              <ContentCard
                key={item.id}
                heading={item.program}
                pdf={item.pdf}
              />
            ))}
        </div>

      </section>

      <Backtotop />
    </div>
  );
};

export default Ece_stud_activity;
